const state = () => ({
  breadcrumb: null
})

const actions = {
  SET_BREADCRUMB: ({ commit }, payload) => {
    commit('SET_BREADCRUMB', payload)
  },
  CLEAR_BREADCRUMB: ({ commit }) => {
    commit('SET_BREADCRUMB', null)
  }
}

const mutations = {
  SET_BREADCRUMB: (state, payload) => {
    state.breadcrumb = payload
  }
}

const getters = {
  BREADCRUMB: state => {
    return state.breadcrumb
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
